@if (singleColumn) {
  <div class="m-0 p-0 d-flex flex-column {{ type === 'IMAGE' ? '' : 'border-bottom border-dark-subtle' }} {{ firstRow ? '' : 'mt-3' }} {{ textColor != ''  ? textColor : '' }}">
    @if (caption != '') {
      <p class="m-0 p-0 small text-warning-emphasis">
        {{ caption }}
        @if (toolTipCaption != '') {
          <span class="text-warning-emphasis fst-italic" data-bs-toggle="tooltip" data-bs-placement="top" title="{{ toolTipText }}">{{ toolTipCaption }}</span>
        }
      </p>
    }
    @if (type === 'ICON') {
      <i
      class="m-0 p-0 {{ value != ''  ? value : 'bi bi-three-dots' }} {{ textAlign === 'CENTER' ? 'text-center' : textAlign === 'RIGHT' ? 'text-end' : 'text-start' }}"></i>
    } @else if (type === 'DATE') {
      <p class="m-0 p-0 {{ textAlign === 'CENTER' ? 'text-center' : textAlign === 'RIGHT' ? 'text-end' : 'text-start' }}">
      {{ value.trim() === '' ? '&nbsp;' : value | date:'medium' }}</p>
    } @else if (type === 'NUMBER') {
      <p class="m-0 p-0 {{ textAlign === 'CENTER' ? 'text-center' : textAlign === 'RIGHT' ? 'text-end' : 'text-start' }}">
      {{ value.trim() === '' ? '&nbsp;' : value | number }}</p>
    } @else if (type === 'IMAGE') {
      <img src="{{ value != '' ? value : baseURL + '/storage/default/user.png' }}" class="object-fit-cover border rounded-circle p-1 {{ textAlign === 'CENTER' ? 'text-center' : textAlign === 'RIGHT' ? 'text-end' : 'text-start' }}" style="height: 7rem !important; width: 7rem !important;" />
    } @else {
      <p class="m-0 p-0 {{ textAlign === 'CENTER' ? 'text-center' : textAlign === 'RIGHT' ? 'text-end' : 'text-start' }}">
      {{ value.trim() === '' ? '&nbsp;' : value }}</p>
    }
  </div>
} @else {
  <div
    class="m-0 p-0 d-flex flex-column border-bottom border-dark-subtle {{ firstRow ? '' : 'mt-3' }} {{ nextColumn ? 'ms-3' : '' }} {{ textColor != ''  ? textColor : '' }}">
    @if (caption != '') {
      <p
        class="m-0 p-0 small text-muted {{ textAlign === 'CENTER' ? 'text-center' : textAlign === 'RIGHT' ? 'text-end' : 'text-start' }}" >
      {{ caption }}</p>
    }
    @if (type === 'ICON') {
      <i
      class="m-0 p-0 {{ value != ''  ? value : 'bi bi-three-dots' }} {{ textAlign === 'CENTER' ? 'text-center' : textAlign === 'RIGHT' ? 'text-end' : 'text-start' }}"></i>
    } @else if (type === 'DATE') {
      <p class="m-0 p-0 {{ textAlign === 'CENTER' ? 'text-center' : textAlign === 'RIGHT' ? 'text-end' : 'text-start' }}">
      {{ value.trim() === '' ? '&nbsp;' : value | date:'medium' }}</p>
    } @else if (type === 'NUMBER') {
      <p class="m-0 p-0 {{ textAlign === 'CENTER' ? 'text-center' : textAlign === 'RIGHT' ? 'text-end' : 'text-start' }}">
      {{ value.trim() === '' ? '&nbsp;' : value | number }}</p>
    } @else if (type === 'IMAGE') {
      <img src="{{ value != '' ? value : baseURL + '/storage/default/user.png' }}"  class="object-fit-cover border rounded-circle p-1 {{ textAlign === 'CENTER' ? 'text-center' : textAlign === 'RIGHT' ? 'text-end' : 'text-start' }}" style="height: 7rem !important; width: 7rem !important;" />
    } @else {
      <p class="m-0 p-0 {{ textAlign === 'CENTER' ? 'text-center' : textAlign === 'RIGHT' ? 'text-end' : 'text-start' }}">
      {{ value.trim() === '' ? '&nbsp;' : value }}</p>
    }
  </div>
}